import { network } from 'services/network';
import { useMutation } from 'react-query';

const mutationFn = (params: QueryParams) => {
    return network.post('api/bo/reorderRankForStoredFilterBulkAssignToUser', params).then((response) => response.data);
};

export const useMutationReorderRankForStoredFilterBulkAssignToUser = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    idList: { id: number; rank: number }[];
    contractId: number;
}
